import { useState } from "react";
import axios from "axios";
import { getAccessToken } from "../utils/authSession";

const usePost = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (body, overrideUrl) => {
    const access_token = getAccessToken();
    setError(null);
    try {
      setLoading(true);
      const response = await axios.post(overrideUrl ?? url, body, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setData(response?.data);
      return response?.data ?? null;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData };
};

export default usePost;
